import { render, staticRenderFns } from "./NodeOnboardingAIRewriteButton.vue?vue&type=template&id=0b96eb20&"
import script from "./NodeOnboardingAIRewriteButton.vue?vue&type=script&lang=ts&"
export * from "./NodeOnboardingAIRewriteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports